import { Component, AfterViewInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from './common/component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AppState } from './app.state';
import { OAuthClient } from './OAuth';
import { IdentityService } from './common/service';
import { InventoryCurrentService } from './common/service/InventoryCurrentService';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { environment } from '../environments/environment';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import $ from 'jquery'
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent extends BaseComponent implements AfterViewInit {
  colors = [""]
  toggle = 0;
  year: number;
  menu = [];
  loggedIn = false;
  previousUrl = '';
  userAccount = false;
  welcome: true;
  ebiz = true;
  oAuth: OAuthClient = new OAuthClient();
  userId = '';
  roles = [];
  eBizDev = false;
  eBillDev = false;
  eBill = false;
  showTime;
  showcount = false;
  showWarning = false;
  interval;
  tokenSubscription = new Subscription();


  constructor(private readonly route: ActivatedRoute, public translate: TranslateService, public router: Router, public state: AppState, public service: IdentityService, public service1: InventoryCurrentService, private titleService: Title) {
    super();
    this.breadcrumbs = [{ name: 'eBiz', link: '' }];
    this.state.breadcrumbsChanged.subscribe(data => {
      this.breadcrumbs = data;
      // Update title based on current breadcrumb
      if (this.breadcrumbs.length > 1) {
        this.titleService.setTitle(`eBiz - ${this.breadcrumbs[this.breadcrumbs.length-1].name}`);
      } else {
        this.titleService.setTitle('eBiz');
      }
    });
    translate.addLangs(['en']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(RegExp(/en|de/).exec(browserLang) ? browserLang : 'en');
    this.year = (new Date()).getFullYear();

    // Set initial title
    this.titleService.setTitle('eBiz');

    // Subscribe to router events to update title
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const currentUrl = this.router.url;
      const currentRoute = this.getActiveRoute(this.router.routerState.root);
      const routeTitle = currentRoute.snapshot.data['title'];
      
      // Handle special cases first based on URL
      if (currentUrl.includes('/login')) {
        this.titleService.setTitle('eBiz - Login');
      } 
      else if (currentUrl.includes('/error') || currentUrl.includes('/not-found')) {
        this.titleService.setTitle('eBiz - Error');
      }
      else if (currentUrl === '/' || currentUrl === '/home') {
        this.titleService.setTitle('eBiz - Home Page');
      }
      // If route data has title, use that next
      else if (routeTitle) {
        this.titleService.setTitle(`eBiz - ${routeTitle}`);
      }
    });
  }

  // Add this helper method to get the active route
  private getActiveRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  } 

  ngAfterViewInit() {
    if (window.location.href.includes('validationSet/')) {
      localStorage.setItem('URL', window.location.href.split("#")[1]);
    }

    this.translate.get('menu').subscribe(data => {
      this.menu = data;
    });

    // Uncomment the below code to test the application in local machine
    // sessionStorage.setItem('access_token','eyJ0eXAiOiJKV1QiLCJub25jZSI6IkdBZkZqOHY4b3E3SU54ZkZoLVR2WFZydXptZTVXY0NhVllVTlpJSl9YbnMiLCJhbGciOiJSUzI1NiIsIng1dCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSIsImtpZCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9lY2FhMzg2Yi1jOGRmLTRjZTAtYWQwMS03NDBjYmRiNWJhNTUvIiwiaWF0IjoxNzQ2MTIzNzQzLCJuYmYiOjE3NDYxMjM3NDMsImV4cCI6MTc0NjEyOTA4OSwiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiLCJ1cm46dXNlcjpyZWdpc3RlcnNlY3VyaXR5aW5mbyJdLCJhaW8iOiJBWFFBaS84WkFBQUFEbHBXQ08wZXoxajFZWGtCZ3ZCT0JkZ2MwMlI5ZzVIU3BXSzYyeEhlWkJSK0kwcW5JUjZGeC92Mm12Qkhac0VZWHIxOEgzTDdsL3B6WlhKZWNHZFA3MGNkUUZVZ2gzeTdVUFhkbS9BdHlkODZEZ2RQUmJjd2JnY1hkRTFnbGtyeE43WXM1RHdQN01jTlZTUVhyR1d0Q2c9PSIsImFtciI6WyJyc2EiLCJtZmEiXSwiYXBwX2Rpc3BsYXluYW1lIjoiQUFTX0FQTi1FQklaLURFVl9PQVVUSF9RVUFMIiwiYXBwaWQiOiJmZjk3MDBlMC05MDY1LTQyOTQtOTQyOS1lM2E4YTI5NDk5NGUiLCJhcHBpZGFjciI6IjEiLCJmYW1pbHlfbmFtZSI6IlBhdGlsIiwiZ2l2ZW5fbmFtZSI6IlByYXNoYW50IEFuaWwiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIyMDguMTI3LjE0NC4xNTciLCJuYW1lIjoiUHJhc2hhbnQgQW5pbCBQYXRpbCIsIm9pZCI6IjM2ZDVmZWM4LTdhYmYtNDk3NC1iNjNiLTI3ZDAwM2M3MDNmOCIsIm9ucHJlbV9zaWQiOiJTLTEtNS0yMS0yMDEwNzQ1NjIxLTMzODE5NjM2NzQtMTU3OTk0MjE4OS0yOTg4NzIyIiwicGxhdGYiOiIzIiwicHVpZCI6IjEwMDMyMDAxMjYwRUFDNjAiLCJyaCI6IjEuQVF3QWF6aXE3Tl9JNEV5dEFYUU12Ylc2VlFNQUFBQUFBQUFBd0FBQUFBQUFBQUFNQUxRTUFBLiIsInNjcCI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIiwic2lkIjoiMDAxNDA1MTktMGUyMC1kZmU0LWE3NTYtZDU4ZjMyYmRkNDgxIiwic2lnbmluX3N0YXRlIjpbImlua25vd25udHdrIiwia21zaSJdLCJzdWIiOiJaNDhiVWZHT0p0enZieFVHVl9zUHRENlNJbkJ4V2I0OUtzcEttQzVLdjhJIiwidGVuYW50X3JlZ2lvbl9zY29wZSI6IkVVIiwidGlkIjoiZWNhYTM4NmItYzhkZi00Y2UwLWFkMDEtNzQwY2JkYjViYTU1IiwidW5pcXVlX25hbWUiOiJQYXRpbFAxOEBiYXNmYWQuYmFzZi5uZXQiLCJ1cG4iOiJQYXRpbFAxOEBiYXNmYWQuYmFzZi5uZXQiLCJ1dGkiOiJ0dXBZQnF2M3BFUy1TdDlMelE4WEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX2Z0ZCI6IjBReDVHWmVIZmJFZkpOWElKRTRubWRzWUZHS0pKbHlwY2RBYUJ3VE93SFVCWlhWeWIzQmxibTl5ZEdndFpITnRjdyIsInhtc19pZHJlbCI6IjggMSIsInhtc19zdCI6eyJzdWIiOiJ4TE5sc05BeUFmUVc0b0JCUGw4Zy1VRkgwaXNkT3BKUDhieWt2clNtTTcwIn0sInhtc190Y2R0IjoxNDAxMzk1MTI0LCJ4bXNfdGRiciI6IkVVIn0.HeaHKuLGE92sbEAPbhE6nbqpMpB-xtmTcY3TBhAUK_EfqQHwrDjMxSRPL3L2684ULf7zz6TLHzvU2Nj6IbXbiKdwyITcJknk7Eyv8Lo5_F-C9z9DWIkEwCahPOUOflIw5cFvOEYuuTb2Xs0fkCuqEpnV32P6iEYlf3eVj-DP1oAKfB7zdJkO_Hv_xEyZZ4dE3pQ4EgPJ0PEsFWwsQabTTi5dvGvX6lXbfW5ittK2XGG5WNHEeWLtJbCXLXPzGVVFQK8Nx16i-v8nimjAbYWGr8EiIixDSRJU9bkyW6TmgCg_uW8AuOTJmXeV8yIDC6EthVMUTSChN35eau7lid47XA');
    // sessionStorage.setItem('id_token','eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IkNOdjBPSTNSd3FsSEZFVm5hb01Bc2hDSDJYRSJ9.eyJhdWQiOiJmZjk3MDBlMC05MDY1LTQyOTQtOTQyOS1lM2E4YTI5NDk5NGUiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vZWNhYTM4NmItYzhkZi00Y2UwLWFkMDEtNzQwY2JkYjViYTU1L3YyLjAiLCJpYXQiOjE3NDYxMjM3NDMsIm5iZiI6MTc0NjEyMzc0MywiZXhwIjoxNzQ2MTI3NjQzLCJncm91cHMiOlsiQUFTX0Jyb2tlcmluZ19Hcm91cF8wMDAxIiwiQVBOX0VCSVpfMjAyM19EX0VCSVoiLCJBUE5fRUJJWl8yMDIzX0RfRUJJTEwiLCJBUE5fRUJJWl8yMDIzX1FfRUJJTEwiLCJBUE5fRUJJWl8yMDIzX1FfRUJJWiJdLCJuYW1lIjoiUHJhc2hhbnQgQW5pbCBQYXRpbCIsIm9pZCI6IjM2ZDVmZWM4LTdhYmYtNDk3NC1iNjNiLTI3ZDAwM2M3MDNmOCIsInByZWZlcnJlZF91c2VybmFtZSI6IlBhdGlsUDE4QGJhc2ZhZC5iYXNmLm5ldCIsInJoIjoiMS5BUXdBYXppcTdOX0k0RXl0QVhRTXZiVzZWZUFBbF85bGtKUkNsQ25qcUtLVW1VNE1BTFFNQUEuIiwic2lkIjoiMDAxNDA1MTktMGUyMC1kZmU0LWE3NTYtZDU4ZjMyYmRkNDgxIiwic3ViIjoieExObHNOQXlBZlFXNG9CQlBsOGctVUZIMGlzZE9wSlA4YnlrdnJTbU03MCIsInRpZCI6ImVjYWEzODZiLWM4ZGYtNGNlMC1hZDAxLTc0MGNiZGI1YmE1NSIsInV0aSI6InR1cFlCcXYzcEVTLVN0OUx6UThYQUEiLCJ2ZXIiOiIyLjAiLCJ1c2VyX2lkIjoiUGF0aWxQMTgifQ.UxU7DDgH0uzenF0A27clrY3zGJU5NjFJroOqqIi_mqgFjh_9Xyz3q2N_YGS9_wJjBDlP30mI87zrTvSCTYS5YINnlPfVOMem-jbpLCu_-chb06T284N-izpDULWgMGiaim626WMCvtz_o0gT5yHw8rcIxodDjIiLErcZ6PkM8Bvi7cI4-Eh_T7yZpWk2_S39RuQJqhec6flfdRJt-Vi4nkDqzSXQtZkoKRcZ1a4JupXvX7dE7M7OKIRTjUrjSDoq2umfZrHRFkCs1gxqXA6PGx_ySBVFtwgD9phqX8U37HxM473Yj6-Pf4tMMGEcuyfGA546sWr4fN-1QSyIY2MCKA');
    // sessionStorage.setItem('refresh_token','1.AQwAaziq7N_I4EytAXQMvbW6VeAAl_9lkJRClCnjqKKUmU4MALQMAA.AgABAwEAAABVrSpeuWamRam2jAF1XRQEAwDs_wUA9P83DL5Jjh22HFgsEcS2uDTWLFJi-JO4sANGZ7mYIAUPN9GPgp-J7y5GEfPaRynvvsaHsyTbEuVNZ8fEo8PXODtctHSN3tOolWcU81FfqwnYP0a5AqnojcP2qRvdCLKQHJODfODYrBdMhwNOVci5GTCMDWBdXtaHRM-u8cqYicatf7ibgG2l_5gm6uH0cD0twjuErc6uugxd3NgTBVc26zO1pBD9rB0EwDI1MBSM0TmMfBLpJyOgPjmcz996G6c-8C5kmQUgtUw-oau55-ozmi3KCjrK_M-t5sZ6P5cF2XTmEeBg2Y4iCv_GTWDAkRj1QlJGiEhisuu3AMeQHojvV12Hwbsxt95WGHjdEcqvzaCnMDbrYfTt_1216j695ab8ZuVGMeJ2m0eAfj-kYgCln6741Q6ChPIKMLM-OZHgFi02ABwQ-KJ6GvkxqEX0ENk83kQOKPkSXsSJ3xnHrmloCwgzxrsAYsT_JHlVmYbGrapUPo_glDmJY1klrhw1wXYmA_-3_lu9_LThE76aW_7PkeUb6_cmHKgFgzfHOTCHIjBMgdKUGKF21QiI2afMbjZyU9uIg1w_uEDvqfh2qNftPJjW50uB7j_9h8d-ShNh2CBnNtCVLoYNWEha1zN_76g5XAHFDm4p6jHE_oI4OwNgEcF4IwXuhuIu0qkBG_QVwtbtc0ewHNyTKhiSY9ENnTYpFUmM8-HVkpDj_NQxe0LenNSHlRHzvjKExYimBotmViCfgWayJ9RfMQEP7NkzHSp0aE0CSxqa8Zz0HlQQg6sNRkmydHBu8P-QhoE87Dg8MUVi0b-W-rsHXNC-iXkypvHutn0Euw0YpiibhuJfXpgoWfKCjMQY_e-I6YXrQQ');
    // sessionStorage.setItem('roles',"MDM-AllUsersWith-basfPersonID,APN-EBIZ-EBILL_EBIZ_DEV_USER,APN-EBIZ-EBILL_EBILL_DEV_USER");
    // sessionStorage.setItem('userId','PatilP18');
    // this.eBizDev = true;
    // this.eBill = true;
    // this.loggedIn = true;
    // this.service.logIn(this.loggedIn);
    // this.service.eBiz();
    // this.service.eBill();

    const access_token = sessionStorage.getItem('access_token');
    const id_token = sessionStorage.getItem('id_token');
    const roles = sessionStorage.getItem('roles') ? sessionStorage.getItem('roles').split(',') : null;
    const userId = sessionStorage.getItem('userId');

    if (access_token) {
      this.state.set('access_token', access_token);
      this.state.set('id_token', id_token);
      this.state.set('roles', roles);
      this.state.set('userId', userId);

      this.checkTokenExpiry();

      this.roles = this.state.get('roles');
      this.userId = this.state.get('userId');

      if (Object.keys(this.roles).length === 0) {
        Swal.fire({
          title: 'Unauthorized User',
          icon: 'error'
        });
      } else {
        for (let i of this.roles) {
          if (i === environment.EBIZ_ROLE) {
            this.eBizDev = true;
            this.loggedIn = true;
            this.service.logIn(this.loggedIn);
            this.service.eBiz();
          } else if (i === environment.EBILL_ROLE) {
            this.eBillDev = true;
            this.eBill = true;
            this.loggedIn = true;
            this.service.logIn(this.loggedIn);
            this.service.eBill();
          }
        }
        if (!this.eBizDev && this.eBillDev) {
          this.router.navigate(['', 'eBill']);
          this.ebiz = false;
        }
      }
      if (!this.eBizDev && !this.eBillDev) {
        Swal.fire({
          title: 'Unauthorized User',
          icon: 'error'
        });
      }

      this.service.logIn(this.loggedIn);
    } else {
      const authCode = sessionStorage.getItem('authCode');
      if (authCode) {
        this.generateAccessToken(authCode);
      } else {
        this.login();
      }
    }
  }

  login() {
    this.startLoader();
    this.oAuth.authenticate().then(success => {
      this.generateAccessToken(success.code);
    }, (error) => {
      this.stopLoader();
      console.log(error);
    });
  }

  generateAccessToken(authCode) {

    localStorage.clear();
    sessionStorage.clear();

    this.service.getAccessToken(authCode).subscribe({
      next: (data: any) => {
        sessionStorage.setItem('access_token', data.access_token);
        this.state.set('access_token', data.access_token);

        sessionStorage.setItem('id_token', data.id_token);
        this.state.set('id_token', data.id_token);

        sessionStorage.setItem('refresh_token', data.refresh_token);
        this.state.set('refresh_token', data.refresh_token);

        sessionStorage.setItem('roles', data['APN_eBiz_groups']);
        this.state.set('roles', data['APN_eBiz_groups']);
        this.roles = data['APN_eBiz_groups'];

        sessionStorage.setItem('userId', data.user_id);
        this.state.set('userId', data.user_id);
        this.userId = data.user_id;

        // Changed to make default expiry time as 12 hours, as new Azure AD expires in an hour
        sessionStorage.setItem('expiry_time', (new Date().getTime() + 43200000).toString());
        sessionStorage.setItem('expiry_notify_time', ((new Date().getTime() + 43200000) - 3600000).toString());

        // Set time to renew the access token in 50 mins as it expires in every hour (all mentioned times are in mili seconds)
        sessionStorage.setItem('token_renewal_time', (new Date().getTime() + 3000000).toString());

        this.checkTokenExpiry();

        if (Object.keys(data).length === 0) {
          Swal.fire({
            title: 'Unauthorized User',
            icon: 'error'
          });
        } else {
          if (typeof this.roles == 'string') {
            if (this.roles === environment.EBIZ_ROLE) {
              this.eBizDev = true;
              this.loggedIn = true;
              this.service.logIn(this.loggedIn);
              this.service.eBiz();
            } else if (this.roles === environment.EBILL_ROLE) {
              this.eBillDev = true;
              this.eBill = true;
              this.loggedIn = true;
              this.service.logIn(this.loggedIn);
              this.service.eBill();
            }
          }
          for (let i of this.roles) {
            if (i === environment.EBIZ_ROLE) {
              this.eBizDev = true;
              this.loggedIn = true;
              this.service.logIn(this.loggedIn);
              this.service.eBiz();
            } else if (i === environment.EBILL_ROLE) {
              this.eBillDev = true;
              this.eBill = true;
              this.loggedIn = true;
              this.service.logIn(this.loggedIn);
              this.service.eBill();
            }
          }
          // Navigate to validation set
          if (localStorage.getItem('URL')?.includes('validationSet/')) {
            this.router.navigate([localStorage.getItem('URL')]);
          }
          if (!this.eBizDev && this.eBillDev) {
            this.router.navigate(['', 'eBill']);
            this.ebiz = false;
          }
        }
        if (!this.eBizDev && !this.eBillDev) {
          Swal.fire({
            title: 'Unauthorized User',
            icon: 'error'
          });
        }
      }, error: (error) => {
        console.log(error);
        Swal.fire({
          title: 'Unauthorized User',
          icon: 'error',
          allowOutsideClick: false
        });
      }
    });
  }

  navigate(event, link) {
    this.previousUrl = link;
    if (link) {
      $('.menu-actions').find('.subaction').removeClass('active');
      $(event.currentTarget).addClass('active');
      this.router.navigate([link], { relativeTo: this.route.parent });
    }
  }

  checkTokenExpiry() {

    setInterval(() => this.startTimer(), 1000);
  }

  startTimer() {

    let currentTime = new Date().getTime();

    if (sessionStorage.getItem("expiry_time") != null) {
      if (Number(sessionStorage.getItem("expiry_notify_time")) <= currentTime && (Number(sessionStorage.getItem("expiry_time")) > currentTime)) {
        this.showcount = true;
        let timeout = Math.floor((Number(sessionStorage.getItem("expiry_time")) - currentTime) / 1000);
        this.showTime = this.transform(timeout);
      }

      if (Number(sessionStorage.getItem("expiry_time")) <= currentTime) {
        if (this.showcount) {
          this.showcount = false;
          clearInterval(this.interval);
          this.showPop();
          return;
        }
      }
    }

    this.checkAccessTokenRenewalTimer(currentTime);
  }

  checkAccessTokenRenewalTimer(currentTime: number) {

    if (sessionStorage.getItem("token_renewal_time") != null) {
      if (Number(sessionStorage.getItem("token_renewal_time")) <= currentTime) {
        console.log("Need to refresh access token");
        this.showWarning = true;

        this.service.getNewAccessToken(sessionStorage.getItem('refresh_token')).subscribe({
          next: (data: any) => {
            sessionStorage.setItem('access_token', data.access_token);
            this.state.set('access_token', data.access_token);

            sessionStorage.setItem('id_token', data.id_token);
            this.state.set('id_token', data.id_token);

            this.showWarning = false;

            // Set time to renew the access token in 50 mins as it expires in every hour (all mentioned times are in mili seconds)
            sessionStorage.setItem('token_renewal_time', (new Date().getTime() + 3000000).toString());

            console.log("Access token refreshed at" + new Date());
          }, error: (error) => {
            console.log(error);
            Swal.fire({
              title: 'Unauthorized User',
              icon: 'error',
              allowOutsideClick: false
            });
          }
        });
      }
    }
  }

  transform(value: number) {
    const minutes: number = Math.floor(value / 60);
    let secs = String((value - minutes * 60)).padStart(2, '0');
    return String(minutes).padStart(2, '0') + ' Mins :' + secs + ' Secs';
  }

  showPop() {
    clearInterval(this.interval);
    Swal.fire({
      title: 'Warning',
      text: 'Your token has expired. You will be redirected to Login page!',
      icon: 'warning',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((res) => {
      if (res.value) {
        sessionStorage.clear();
        localStorage.clear();
        this.oAuth.authenticate();
      }
    })
  }

  expand(event, link) {
    $('.menu-actions').find('.main-menu-action.active').siblings().removeClass('active');
    $('.menu-actions').find('.main-menu-action').not(event.currentTarget).removeClass('active');
    $(event.currentTarget).toggleClass('active');
    if ($(event.currentTarget).hasClass('active')) {
      $(event.currentTarget).siblings().addClass('active');
    }
    if (link !== '') {
      this.router.navigate([link]);
    }
    if ($('.subaction')[28].offsetHeight >= $('.footer')[0].offsetHeight - 1) {
      $('footer').addClass('isScrolled');
      $('footer').removeClass('isNotScrolled');
      $('.toolbar-content').addClass('scroll');
    } else {
      $('.toolbar-content').removeClass('scroll');
      $('footer').addClass('isNotScrolled');
      $('footer').removeClass('isScrolled');
    }

  }
  public getUrl() {
    return this.previousUrl;
  }

  navigateHome(event: Event) {
    $('.menu-actions').find('.main-menu-action.active').siblings().removeClass('active');
    $('.menu-actions').find('.main-menu-action').not(event.currentTarget).removeClass('active');
    $('.menu-actions').find('.subaction').removeClass('active');
    this.router.navigate(['']);
  }

  @HostListener('window:click', ['$event'])
  clickout(event: Event) {
    const target = event.target as HTMLElement;
    if (target.id === 'user') {
        this.userAccount = !this.userAccount;
    } else {
        this.userAccount = false;
        $('.userProfile').removeClass('userClicked');
    }
  }

  toggleEbiz() {
    this.ebiz = !this.ebiz;
    this.state.set('ebiz', this.ebiz);
  }

  userProfileClicked() {
    if ($('.userProfile').hasClass('userClicked'))
      $('.userProfile').removeClass('userClicked');
    else
      $('.userProfile').addClass('userClicked');
  }

  getRoles() {
    return this.roles.length !== 0;
  }
}
